// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1dlLg","selected":"Chip_selected___8XrK"};